// Refuse-with-upgrade-offer (slice-2-onboarding.md §2.4; ADR-0016 §8; D27/D58 - never a
// price). A full-width takeover card, never a blocking modal (a modal traps focus and
// this is a real dead end without an exit - §2.4.1). Two real ways forward plus "Back
// to your apps," which always works.
import type { AppLimitRefusal } from "../api/errors.js";

// `plan` is a plain string on the wire (the server may report "unknown" when the plan
// row is missing - entitlement fails closed); label the known tiers, else show as-is.
const PLAN_LABEL: Record<string, string> = {
  solo: "Solo",
  studio: "Studio",
  business: "Business",
};
const planLabel = (plan: string): string => PLAN_LABEL[plan] ?? plan;

export const RefusalCard = ({
  refusal,
  onAskAboutUpgrading,
  onFreeUpASlot,
  onBackToApps,
}: {
  readonly refusal: AppLimitRefusal;
  readonly onAskAboutUpgrading: () => void;
  readonly onFreeUpASlot: () => void;
  readonly onBackToApps: () => void;
}): React.JSX.Element => (
  <div className="card state-card refusal" role="region" aria-label="App limit reached">
    <div className="h3">You&apos;re at {planLabel(refusal.plan)}&apos;s app limit</div>
    <p className="muted">
      {refusal.appsUsed} of {refusal.appLimit} apps used.
    </p>
    <div className="actions">
      <button type="button" className="btn btn-primary" onClick={onAskAboutUpgrading}>
        Ask about upgrading
      </button>
      <button type="button" className="btn btn-ghost" onClick={onFreeUpASlot}>
        Free up a slot instead
      </button>
    </div>
    <button type="button" className="btn btn-ghost btn-sm" onClick={onBackToApps}>
      Back to your apps
    </button>
  </div>
);
